import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Plane2Model, PlaneTextureData } from '../../model';
import { EntityDragEvent } from '../mouse/mouse-entity.service';
import { BoundingBox2FromCenterSize } from '../../share/boundingbox2';
import { Vector2 } from 'three';
import { CanvasService } from '../../components/canvas.service';

@Component({
  selector: 'ng3-move-plane',
  templateUrl: './move-plane.component.html',
  styleUrls: ['./move-plane.component.css'],
})
export class MovePlaneComponent implements OnInit {
  constructor(private canvas: CanvasService) {}

  @Input() model: Plane2Model = DEFAULT_MAIN_MODEL;
  @Output() drag = new EventEmitter<EntityDragEvent>();
  ngOnInit() {}
  onDrag(e: EntityDragEvent) {
    this.drag.emit(e);
  }
  setStyle(isHover: boolean) {
    this.canvas.domElement.style.cursor = isHover ? 'move' : 'auto';
  }
}
const DEFAULT_MAIN_TEXTURE: PlaneTextureData = {
  r: new Uint8Array([255]),
  g: new Uint8Array([255]),
  b: new Uint8Array([255]),
  shape: new Vector2(1, 1),
};
const DEFAULT_MAIN_MODEL = new Plane2Model(
  new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(10, 10)),
  10,
  DEFAULT_MAIN_TEXTURE
);
